/**
 * Nombres de rol Copilot (`role.name` en availableRoles).
 * Deben coincidir con los valores que devuelve el backend por venue.
 */
export const COPILOT_ROLE_NAMES = {
	HOST: 'Host',
	SALA: 'Sala',
	BARRA: 'Barra',
	COCINA: 'Cocina',
	CAMARERO_COMIDA: 'Camarero de comida',
	CAMARERO_BEBIDA: 'Camarero de bebida',
	/** Mismo alcance operativo que Sala (un solo camarero en sala). */
	EN_SALA: '1 en Sala',
	TPV_BARRA: 'TPV + Barra',
	TPV: 'TPV',
	PASANTE: 'Pasante',
};

/**
 * @param {string} [roleName]
 * @returns {string}
 */
export function normalizeCopilotRoleName(roleName) {
	return (roleName ?? '')
		.trim()
		.toLowerCase()
		.normalize('NFD')
		.replace(/\p{Diacritic}/gu, '')
		.replace(/\s+/g, ' ');
}

/**
 * Rol «1 en Sala» es operativamente equivalente a Sala.
 * @param {string} [roleName]
 * @returns {boolean}
 */
export function isSalaLikeRole(roleName) {
	const normalized = normalizeCopilotRoleName(roleName);
	return normalized === normalizeCopilotRoleName(COPILOT_ROLE_NAMES.SALA) || normalized === '1 en sala';
}

/**
 * Rol «TPV + Barra» (`role.name` del backend).
 * @param {string} [roleName]
 * @returns {boolean}
 */
export function isTpvPlusBarraRole(roleName) {
	return normalizeCopilotRoleName(roleName) === normalizeCopilotRoleName(COPILOT_ROLE_NAMES.TPV_BARRA);
}

/**
 * Rol «TPV» puro (no «TPV + Barra»).
 * @param {string} [roleName]
 * @returns {boolean}
 */
export function isTpvRole(roleName) {
	return normalizeCopilotRoleName(roleName) === normalizeCopilotRoleName(COPILOT_ROLE_NAMES.TPV);
}

/**
 * Roles que pueden filtrar bebidas a preparar por partida.
 * @param {string} [roleName]
 * @returns {boolean}
 */
export function roleUsesDrinksPartidaFilter(roleName) {
	return isTpvRole(roleName) || isTpvPlusBarraRole(roleName);
}

/**
 * @param {string[]} allowedRoleNames
 * @param {string} [selectedRoleName]
 * @returns {boolean}
 */
export function isRoleAllowedByProtocol(allowedRoleNames, selectedRoleName) {
	if (!allowedRoleNames?.length) return true;
	if (!selectedRoleName) return false;

	return allowedRoleNames.some(
		(allowed) =>
			allowed === selectedRoleName ||
			(isSalaLikeRole(allowed) && isSalaLikeRole(selectedRoleName)),
	);
}
